import ExquraFooter from "@/components/home/ExquraFooter";
import { useSiteContent } from "./useSiteContent";

/** The footer is shared chrome rendered on every page (Home.jsx directly,
 * every other public page via Layout.jsx) rather than a block inside any
 * one page's own content array — so it fetches its own siteContent doc
 * instead of receiving `fields` from a parent BlockRenderer. Editing it in
 * "Edit Site" still goes through the exact same block-editor UI, just
 * under the "Footer" page entry, whose single "footer-content" block is
 * this doc's only block. */
export default function SiteFooter() {
  const { blocks } = useSiteContent("footer");
  return <ExquraFooter fields={blocks[0]?.fields} />;
}
